export function animateCSS(node: Element, animation: string, prefix = "animate__"): Promise<void> {
  // We create a Promise and return it
  return new Promise((resolve) => {
    const animationName = `${prefix}${animation}`;

    node.classList.add(`${prefix}animated`, animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(): void {
      node.classList.remove(`${prefix}animated`, animationName);
      node.removeEventListener("animationend", handleAnimationEnd);

      resolve();
    }

    node.addEventListener("animationend", handleAnimationEnd);
  });
}
